import { useQueryClient } from '@tanstack/react-query';

import { useEventSubscription } from '~/hooks/useEventSubscription';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { getWorkspaceAddOnsKey } from '~/swr-hooks/workspaces/addOns/useCurrentWorkspaceAddOns';
import { type EventSubscriptionArgs } from '~/types/sockets';

export const useHandleWorkspaceAddOnsUpdated = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const queryClient = useQueryClient();

  const event: EventSubscriptionArgs<'Activity.Workspace.AddOns.updated'> = {
    eventType: 'Activity.Workspace.AddOns.updated',
  };

  useEventSubscription({
    currentWorkspaceId: currentWorkspace?.id,
    event,
    options: {
      onUpdate: ({ data: { workspaceId } }) => {
        queryClient.invalidateQueries({ queryKey: getWorkspaceAddOnsKey(workspaceId) });
      },
    },
  });
};
